export const initialData = [
  {
    country: "Afghanistan",
    region: "Asia",
    capital: "Kabul",
    id: 0,
  },
  {
    country: "Albania",
    region: "Europe",
    capital: "Tirana",
    id: 1,
  },
  {
    country: "Algeria",
    region: "Africa",
    capital: "Algiers",
    id: 2,
  },
  {
    country: "Andorra",
    region: "Europe",
    capital: "Andorra la Vella",
    id: 3,
  },
  {
    country: "Angola",
    region: "Africa",
    capital: "Luanda",
    id: 4,
  },
  {
    country: "Antigua and Barbuda",
    region: "Americas",
    capital: "Saint John's",
    id: 5,
  },
  {
    country: "Argentina",
    region: "Americas",
    capital: "Buenos Aires",
    id: 6,
  },
  {
    country: "Armenia",
    region: "Asia",
    capital: "Yerevan",
    id: 7,
  },
  {
    country: "Australia",
    region: "Oceania",
    capital: "Canberra",
    id: 8,
  },
  {
    country: "Austria",
    region: "Europe",
    capital: "Vienna",
    id: 9,
  },
  {
    country: "Azerbaijan",
    region: "Asia",
    capital: "Baku",
    id: 10,
  },
  {
    country: "Bahamas",
    region: "Americas",
    capital: "Nassau",
    id: 11,
  },
  {
    country: "Bahrain",
    region: "Asia",
    capital: "Manama",
    id: 12,
  },
  {
    country: "Bangladesh",
    region: "Asia",
    capital: "Dhaka",
    id: 13,
  },
  {
    country: "Barbados",
    region: "Americas",
    capital: "Bridgetown",
    id: 14,
  },
  {
    country: "Belarus",
    region: "Europe",
    capital: "Minsk",
    id: 15,
  },
  {
    country: "Belgium",
    region: "Europe",
    capital: "Brussels",
    id: 16,
  },
  {
    country: "Belize",
    region: "Americas",
    capital: "Belmopan",
    id: 17,
  },
  {
    country: "Benin",
    region: "Africa",
    capital: "Porto-Novo",
    id: 18,
  },
  {
    country: "Bhutan",
    region: "Asia",
    capital: "Thimphu",
    id: 19,
  },
  {
    country: "Bolivia",
    region: "Americas",
    capital: "Sucre",
    id: 20,
  },
  {
    country: "Bosnia and Herzegovina",
    region: "Europe",
    capital: "Sarajevo",
    id: 21,
  },
  {
    country: "Botswana",
    region: "Africa",
    capital: "Gaborone",
    id: 22,
  },
  {
    country: "Brazil",
    region: "Americas",
    capital: "Brasilia",
    id: 23,
  },
  {
    country: "Brunei",
    region: "Asia",
    capital: "Bandar Seri Begawan",
    id: 24,
  },
  {
    country: "Bulgaria",
    region: "Europe",
    capital: "Sofia",
    id: 25,
  },
  {
    country: "Burkina Faso",
    region: "Africa",
    capital: "Ouagadougou",
    id: 26,
  },
  {
    country: "Burundi",
    region: "Africa",
    capital: "Gitega",
    id: 27,
  },
  {
    country: "Cabo Verde",
    region: "Africa",
    capital: "Praia",
    id: 28,
  },
  {
    country: "Cambodia",
    region: "Asia",
    capital: "Phnom Penh",
    id: 29,
  },
  {
    country: "Cameroon",
    region: "Africa",
    capital: "Yaounde",
    id: 30,
  },
  {
    country: "Canada",
    region: "Americas",
    capital: "Ottawa",
    id: 31,
  },
  {
    country: "Central African Republic",
    region: "Africa",
    capital: "Bangui",
    id: 32,
  },
  {
    country: "Chad",
    region: "Africa",
    capital: "N'Djamena",
    id: 33,
  },
  {
    country: "Chile",
    region: "Americas",
    capital: "Santiago",
    id: 34,
  },
  {
    country: "China",
    region: "Asia",
    capital: "Beijing",
    id: 35,
  },
  {
    country: "Colombia",
    region: "Americas",
    capital: "Bogota",
    id: 36,
  },
  {
    country: "Comoros",
    region: "Africa",
    capital: "Moroni",
    id: 37,
  },
  {
    country: "Congo",
    region: "Africa",
    capital: "Brazzaville",
    id: 38,
  },
  {
    country: "Costa Rica",
    region: "Americas",
    capital: "San Jose",
    id: 39,
  },
  {
    country: "Croatia",
    region: "Europe",
    capital: "Zagreb",
    id: 40,
  },
  {
    country: "Cuba",
    region: "Americas",
    capital: "Havana",
    id: 41,
  },
  {
    country: "Cyprus",
    region: "Europe",
    capital: "Nicosia",
    id: 42,
  },
  {
    country: "Czech Republic",
    region: "Europe",
    capital: "Praha",
    id: 43,
  },
  {
    country: "Denmark",
    region: "Europe",
    capital: "Copenhagen",
    id: 44,
  },
  {
    country: "Djibouti",
    region: "Africa",
    capital: "Djibouti",
    id: 45,
  },
  {
    country: "Dominica",
    region: "Americas",
    capital: "Roseau",
    id: 46,
  },
  {
    country: "Dominican Republic",
    region: "Americas",
    capital: "Santo Domingo",
    id: 47,
  },
  {
    country: "Ecuador",
    region: "Americas",
    capital: "Quito",
    id: 48,
  },
  {
    country: "Egypt",
    region: "Africa",
    capital: "Cairo",
    id: 49,
  },
  {
    country: "El Salvador",
    region: "Americas",
    capital: "San Salvador",
    id: 50,
  },
  {
    country: "Equatorial Guinea",
    region: "Africa",
    capital: "Malabo",
    id: 51,
  },
  {
    country: "Eritrea",
    region: "Africa",
    capital: "Asmara",
    id: 52,
  },
  {
    country: "Estonia",
    region: "Europe",
    capital: "Tallinn",
    id: 53,
  },
  {
    country: "Eswatini",
    region: "Africa",
    capital: "Mbabane",
    id: 54,
  },
  {
    country: "Ethiopia",
    region: "Africa",
    capital: "Addis Ababa",
    id: 55,
  },
  {
    country: "Fiji",
    region: "Oceania",
    capital: "Suva",
    id: 56,
  },
  {
    country: "Finland",
    region: "Europe",
    capital: "Helsinki",
    id: 57,
  },
  {
    country: "France",
    region: "Europe",
    capital: "Paris",
    id: 58,
  },
  {
    country: "Gabon",
    region: "Africa",
    capital: "Libreville",
    id: 59,
  },
  {
    country: "Gambia",
    region: "Africa",
    capital: "Banjul",
    id: 60,
  },
  {
    country: "Georgia",
    region: "Asia",
    capital: "Tbilisi",
    id: 61,
  },
  {
    country: "Germany",
    region: "Europe",
    capital: "Berlin",
    id: 62,
  },
  {
    country: "Ghana",
    region: "Africa",
    capital: "Accra",
    id: 63,
  },
  {
    country: "Greece",
    region: "Europe",
    capital: "Athens",
    id: 64,
  },
  {
    country: "Grenada",
    region: "Americas",
    capital: "Saint George's",
    id: 65,
  },
  {
    country: "Guatemala",
    region: "Americas",
    capital: "Guatemala City",
    id: 66,
  },
  {
    country: "Guinea",
    region: "Africa",
    capital: "Conakry",
    id: 67,
  },
  {
    country: "Guinea-Bissau",
    region: "Africa",
    capital: "Bissau",
    id: 68,
  },
  {
    country: "Guyana",
    region: "Americas",
    capital: "Georgetown",
    id: 69,
  },
  {
    country: "Haiti",
    region: "Americas",
    capital: "Port-au-Prince",
    id: 70,
  },
  {
    country: "Honduras",
    region: "Americas",
    capital: "Tegucigalpa",
    id: 71,
  },
  {
    country: "Hungary",
    region: "Europe",
    capital: "Budapest",
    id: 72,
  },
  {
    country: "Iceland",
    region: "Europe",
    capital: "Reykjavik",
    id: 73,
  },
  {
    country: "India",
    region: "Asia",
    capital: "New Delhi",
    id: 74,
  },
  {
    country: "Indonesia",
    region: "Asia",
    capital: "Jakarta",
    id: 75,
  },
  {
    country: "Iran",
    region: "Asia",
    capital: "Tehran",
    id: 76,
  },
  {
    country: "Iraq",
    region: "Asia",
    capital: "Baghdad",
    id: 77,
  },
  {
    country: "Ireland",
    region: "Europe",
    capital: "Dublin",
    id: 78,
  },
  {
    country: "Israel",
    region: "Asia",
    capital: "Jerusalem",
    id: 79,
  },
  {
    country: "Italy",
    region: "Europe",
    capital: "Roma",
    id: 80,
  },
  {
    country: "Ivory Coast",
    region: "Africa",
    capital: "Yamoussoukro",
    id: 81,
  },
  {
    country: "Jamaica",
    region: "Americas",
    capital: "Kingston",
    id: 82,
  },
  {
    country: "Japan",
    region: "Asia",
    capital: "Tokyo",
    id: 83,
  },
  {
    country: "Jordan",
    region: "Asia",
    capital: "Amman",
    id: 84,
  },
  {
    country: "Kazakhstan",
    region: "Asia",
    capital: "Astana",
    id: 85,
  },
  {
    country: "Kenya",
    region: "Africa",
    capital: "Nairobi",
    id: 86,
  },
  {
    country: "Kiribati",
    region: "Oceania",
    capital: "South Tarawa",
    id: 87,
  },
  {
    country: "Kosovo",
    region: "Europe",
    capital: "Pristina",
    id: 88,
  },
  {
    country: "Kuwait",
    region: "Asia",
    capital: "Kuwait City",
    id: 89,
  },
  {
    country: "Kyrgyzstan",
    region: "Asia",
    capital: "Bishkek",
    id: 90,
  },
  {
    country: "Laos",
    region: "Asia",
    capital: "Vientiane",
    id: 91,
  },
  {
    country: "Latvia",
    region: "Europe",
    capital: "Riga",
    id: 92,
  },
  {
    country: "Lebanon",
    region: "Asia",
    capital: "Beirut",
    id: 93,
  },
  {
    country: "Lesotho",
    region: "Africa",
    capital: "Maseru",
    id: 94,
  },
  {
    country: "Liberia",
    region: "Africa",
    capital: "Monrovia",
    id: 95,
  },
  {
    country: "Libya",
    region: "Africa",
    capital: "Tripoli",
    id: 96,
  },
  {
    country: "Liechtenstein",
    region: "Europe",
    capital: "Vaduz",
    id: 97,
  },
  {
    country: "Lithuania",
    region: "Europe",
    capital: "Vilnius",
    id: 98,
  },
  {
    country: "Luxembourg",
    region: "Europe",
    capital: "Luxembourg",
    id: 99,
  },
  {
    country: "Madagascar",
    region: "Africa",
    capital: "Antananarivo",
    id: 100,
  },
  {
    country: "Malawi",
    region: "Africa",
    capital: "Lilongwe",
    id: 101,
  },
  {
    country: "Malaysia",
    region: "Asia",
    capital: "Kuala Lumpur",
    id: 102,
  },
  {
    country: "Maldives",
    region: "Asia",
    capital: "Male",
    id: 103,
  },
  {
    country: "Mali",
    region: "Africa",
    capital: "Bamako",
    id: 104,
  },
  {
    country: "Malta",
    region: "Europe",
    capital: "Valletta",
    id: 105,
  },
  {
    country: "Marshall Islands",
    region: "Oceania",
    capital: "Majuro",
    id: 106,
  },
  {
    country: "Democratic Republic of the Congo",
    region: "Africa",
    capital: "Kinshasa",
    id: 107,
  },
  {
    country: "Mauritania",
    region: "Africa",
    capital: "Nouakchott",
    id: 108,
  },
  {
    country: "Mauritius",
    region: "Africa",
    capital: "Port Louis",
    id: 109,
  },
  {
    country: "East Timor",
    region: "Asia",
    capital: "Dili",
    id: 110,
  },
  {
    country: "Mexico",
    region: "Americas",
    capital: "Mexico City",
    id: 111,
  },
  {
    country: "Micronesia",
    region: "Oceania",
    capital: "Palikir",
    id: 112,
  },
  {
    country: "Moldova",
    region: "Europe",
    capital: "Chisinau",
    id: 113,
  },
  {
    country: "Monaco",
    region: "Europe",
    capital: "Monaco",
    id: 114,
  },
  {
    country: "Mongolia",
    region: "Asia",
    capital: "Ulaanbaatar",
    id: 115,
  },
  {
    country: "Montenegro",
    region: "Europe",
    capital: "Podgorica",
    id: 116,
  },
  {
    country: "Morocco",
    region: "Africa",
    capital: "Rabat",
    id: 117,
  },
  {
    country: "Mozambique",
    region: "Africa",
    capital: "Maputo",
    id: 118,
  },
  {
    country: "Myanmar",
    region: "Asia",
    capital: "Nay Pyi Taw",
    id: 119,
  },
  {
    country: "Namibia",
    region: "Africa",
    capital: "Windhoek",
    id: 120,
  },
  {
    country: "Nauru",
    region: "Oceania",
    capital: "Yaren",
    id: 121,
  },
  {
    country: "Nepal",
    region: "Asia",
    capital: "Kathmandu",
    id: 122,
  },
  {
    country: "Netherlands",
    region: "Europe",
    capital: "Amsterdam",
    id: 123,
  },
  {
    country: "New Zealand",
    region: "Oceania",
    capital: "Wellington",
    id: 124,
  },
  {
    country: "Nicaragua",
    region: "Americas",
    capital: "Managua",
    id: 125,
  },
  {
    country: "Niger",
    region: "Africa",
    capital: "Niamey",
    id: 126,
  },
  {
    country: "Nigeria",
    region: "Africa",
    capital: "Abuja",
    id: 127,
  },
  {
    country: "North Korea",
    region: "Asia",
    capital: "Pyongyang",
    id: 128,
  },
  {
    country: "North Macedonia",
    region: "Europe",
    capital: "Skopje",
    id: 129,
  },
  {
    country: "Norway",
    region: "Europe",
    capital: "Oslo",
    id: 130,
  },
  {
    country: "Oman",
    region: "Asia",
    capital: "Muscat",
    id: 131,
  },
  {
    country: "Pakistan",
    region: "Asia",
    capital: "Islamabad",
    id: 132,
  },
  {
    country: "Palau",
    region: "Oceania",
    capital: "Ngerulmud",
    id: 133,
  },
  {
    country: "Panama",
    region: "Americas",
    capital: "Panama City",
    id: 134,
  },
  {
    country: "Papua New Guinea",
    region: "Oceania",
    capital: "Port Moresby",
    id: 135,
  },
  {
    country: "Paraguay",
    region: "Americas",
    capital: "Asuncion",
    id: 136,
  },
  {
    country: "Peru",
    region: "Americas",
    capital: "Lima",
    id: 137,
  },
  {
    country: "Philippines",
    region: "Asia",
    capital: "Manila",
    id: 138,
  },
  {
    country: "Pitcairn",
    region: "Oceania",
    capital: "Adamstown",
    id: 139,
  },
  {
    country: "Poland",
    region: "Europe",
    capital: "Warsaw",
    id: 140,
  },
  {
    country: "Portugal",
    region: "Europe",
    capital: "Lisbon",
    id: 141,
  },
  {
    country: "Qatar",
    region: "Asia",
    capital: "Doha",
    id: 142,
  },
  {
    country: "Romania",
    region: "Europe",
    capital: "Bucharest",
    id: 143,
  },
  {
    country: "Russia",
    region: "Europe",
    capital: "Moscow",
    id: 144,
  },
  {
    country: "Rwanda",
    region: "Africa",
    capital: "Kigali",
    id: 145,
  },
  {
    country: "Saint Kitts and Nevis",
    region: "Americas",
    capital: "Basseterre",
    id: 146,
  },
  {
    country: "Saint Lucia",
    region: "Americas",
    capital: "Castries",
    id: 147,
  },
  {
    country: "Saint Vincent and the Grenadines",
    region: "Americas",
    capital: "Kingstown",
    id: 148,
  },
  {
    country: "Samoa",
    region: "Oceania",
    capital: "Apia",
    id: 149,
  },
  {
    country: "San Marino",
    region: "Europe",
    capital: "San Marino",
    id: 150,
  },
  {
    country: "Sao Tome and Principe",
    region: "Africa",
    capital: "Sao Tome",
    id: 151,
  },
  {
    country: "Saudi Arabia",
    region: "Asia",
    capital: "Riyadh",
    id: 152,
  },
  {
    country: "Senegal",
    region: "Africa",
    capital: "Dakar",
    id: 153,
  },
  {
    country: "Serbia",
    region: "Europe",
    capital: "Belgrade",
    id: 154,
  },
  {
    country: "Seychelles",
    region: "Africa",
    capital: "Victoria",
    id: 155,
  },
  {
    country: "Sierra Leone",
    region: "Africa",
    capital: "Freetown",
    id: 156,
  },
  {
    country: "Singapore",
    region: "Asia",
    capital: "Singapore",
    id: 157,
  },
  {
    country: "Slovakia",
    region: "Europe",
    capital: "Bratislava",
    id: 158,
  },
  {
    country: "Slovenia",
    region: "Europe",
    capital: "Ljubljana",
    id: 159,
  },
  {
    country: "Solomon Islands",
    region: "Oceania",
    capital: "Honiara",
    id: 160,
  },
  {
    country: "Somalia",
    region: "Africa",
    capital: "Mogadishu",
    id: 161,
  },
  {
    country: "South Africa",
    region: "Africa",
    capital: "Pretoria",
    id: 162,
  },
  {
    country: "South Korea",
    region: "Asia",
    capital: "Seoul",
    id: 163,
  },
  {
    country: "South Sudan",
    region: "Africa",
    capital: "Juba",
    id: 164,
  },
  {
    country: "Spain",
    region: "Europe",
    capital: "Madrid",
    id: 165,
  },
  {
    country: "Sudan",
    region: "Africa",
    capital: "Khartum",
    id: 166,
  },
  {
    country: "Suriname",
    region: "Americas",
    capital: "Paramaribo",
    id: 167,
  },
  {
    country: "Sri Lanka",
    region: "Asia",
    capital: "Sri Jayawardenepura Kotte",
    id: 168,
  },
  {
    country: "Sweden",
    region: "Europe",
    capital: "Stockholm",
    id: 169,
  },
  {
    country: "Switzerland",
    region: "Europe",
    capital: "Bern",
    id: 170,
  },
  {
    country: "Syria",
    region: "Asia",
    capital: "Damascus",
    id: 171,
  },
  {
    country: "Tajikistan",
    region: "Asia",
    capital: "Dushanbe",
    id: 172,
  },
  {
    country: "Tanzania",
    region: "Africa",
    capital: "Dodoma",
    id: 173,
  },
  {
    country: "Thailand",
    region: "Asia",
    capital: "Bangkok",
    id: 174,
  },
  {
    country: "Togo",
    region: "Africa",
    capital: "Lome",
    id: 175,
  },
  {
    country: "Tonga",
    region: "Oceania",
    capital: "Nuku'alofa",
    id: 176,
  },
  {
    country: "Trinidad and Tobago",
    region: "Americas",
    capital: "Port of Spain",
    id: 177,
  },
  {
    country: "Tunisia",
    region: "Africa",
    capital: "Tunis",
    id: 178,
  },
  {
    country: "Turkey",
    region: "Asia",
    capital: "Ankara",
    id: 179,
  },
  {
    country: "Turkmenistan",
    region: "Asia",
    capital: "Ashgabat",
    id: 180,
  },
  {
    country: "Tuvalu",
    region: "Oceania",
    capital: "Funafuti",
    id: 181,
  },
  {
    country: "Uganda",
    region: "Africa",
    capital: "Kampala",
    id: 182,
  },
  {
    country: "Ukraine",
    region: "Europe",
    capital: "Kiev",
    id: 183,
  },
  {
    country: "United Arab Emirates",
    region: "Asia",
    capital: "Abu Dhabi",
    id: 184,
  },
  {
    country: "United Kingdom",
    region: "Europe",
    capital: "London",
    id: 185,
  },
  {
    country: "United States",
    region: "Americas",
    capital: "Washington",
    id: 186,
  },
  {
    country: "Uruguay",
    region: "Americas",
    capital: "Montevideo",
    id: 187,
  },
  {
    country: "Uzbekistan",
    region: "Asia",
    capital: "Tashkent",
    id: 188,
  },
  {
    country: "Vanuatu",
    region: "Oceania",
    capital: "Port Vila",
    id: 189,
  },
  {
    country: "Venezuela",
    region: "Americas",
    capital: "Caracas",
    id: 190,
  },
  {
    country: "Vietnam",
    region: "Asia",
    capital: "Hanoi",
    id: 191,
  },
  {
    country: "Yemen",
    region: "Asia",
    capital: "Sanaa",
    id: 192,
  },
  {
    country: "Zambia",
    region: "Africa",
    capital: "Lusaka",
    id: 193,
  },
  {
    country: "Zimbabwe",
    region: "Africa",
    capital: "Harare",
    id: 194,
  },
];
